import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import MenuIcon from '@material-ui/icons/Menu'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import HomeIcon from '@material-ui/icons/Home'
import SettingsIcon from '@material-ui/icons/Settings'
import ImportExportIcon from '@material-ui/icons/ImportExport'

const icons = {
  add: AddIcon,
  edit: EditIcon,
  delete: DeleteIcon,
  menu: MenuIcon,
  moreVert: MoreVertIcon,
  home: HomeIcon,
  settings: SettingsIcon,
  importExport: ImportExportIcon,
}

export default icons